import { formConstants } from '../../../../utils/constants/form-constants';
import { getFileStates, getPaymentStatuses, getOrderTypes } from './account-form-data-utils';
import { formMessageConstants } from '../../../../utils/constants/form-message-constants';


const OrderHistoryDisplayFormData = (accountFormData) => {
    function buildOrderHistoryFormData() {
        const {
            getOrderHistoryCallbackUrl,
            getOrderHistoryPagesCallbackUrl,
            getOrderDetailsCallbackUrl,
            downloadDocumentPdfCallbackUrl,
            downloadFileSummaryPdfCallbackUrl,
            ssoOrderHistoryFields,
            ssoUserDetailsFields,
            ssoDomain,
            resumePaymentCallbackUrl,
            secutixAuthUrl,
            ssoAccountHomePageFields
        } = accountFormData;
        const formData = {};
        const {
            formTitle,
            noOrdersFoundText,
            noProductsFoundText,
            noPaymentSummaryFoundText,
            noDeliveryDataFoundText,
            noHistoryDataFoundText,
            mastercardDialogBox,
            mastercardDialogBoxBanner,
            showDialogBox,
            showCancelButton
        } = ssoOrderHistoryFields;

        const {
            loadingErrorMessage,
            elapsedTimeLimit,
        } = ssoAccountHomePageFields;

        const { country } = ssoUserDetailsFields;

        formData[formConstants.getOrderHistoryCallbackUrl] = getOrderHistoryCallbackUrl;
        formData[formConstants.getOrderHistoryPagesCallbackUrl] = getOrderHistoryPagesCallbackUrl;
        formData[formConstants.getOrderDetailsCallbackUrl] = getOrderDetailsCallbackUrl;
        formData[formConstants.downloadDocumentPdfCallbackUrl] = downloadDocumentPdfCallbackUrl;
        formData[formConstants.downloadFileSummaryPdfCallbackUrl] = downloadFileSummaryPdfCallbackUrl;
        formData[formConstants.resumePaymentCallbackUrl] = resumePaymentCallbackUrl;
        formData[formConstants.secutixAuthUrl] = secutixAuthUrl;
        formData[formConstants.formTitle] = formTitle;
        formData[formConstants.noOrdersFoundText] = noOrdersFoundText || formMessageConstants.noOrdersFoundText;
        formData[formConstants.noProductsFoundText] = noProductsFoundText || formMessageConstants.noProductsFoundText;
        formData[formConstants.noPaymentSummaryFoundText] = noPaymentSummaryFoundText || formMessageConstants.noPaymentSummaryFoundText;
        formData[formConstants.noDeliveryDataFoundText] = noDeliveryDataFoundText || formMessageConstants.noDeliveryDataFoundText;
        formData[formConstants.noHistoryDataFoundText] = noHistoryDataFoundText || formMessageConstants.noHistoryDataFoundText;
        formData[formConstants.masterCardDialogBox] = mastercardDialogBox;
        formData[formConstants.masterCardDialogBoxBanner] = mastercardDialogBoxBanner;
        formData[formConstants.showDialogBox] = showDialogBox;
        formData[formConstants.showCancelButton] = showCancelButton;

        formData[formConstants.fileState] = getFileStates(ssoOrderHistoryFields);
        formData[formConstants.paymentStatus] = getPaymentStatuses(ssoOrderHistoryFields);
        formData[formConstants.orderType] = getOrderTypes(ssoOrderHistoryFields);

        formData[formConstants.country] = country;
        formData[formConstants.ssoDomain] = ssoDomain;

        formData[formConstants.loadingErrorMessage] = loadingErrorMessage;
        formData[formConstants.elapsedTimeLimit] = elapsedTimeLimit;

        return formData;
    }

    return buildOrderHistoryFormData();
};

export default OrderHistoryDisplayFormData;
